import React from 'react';
import PropTypes from 'prop-types';
import Range from './range/range';

const SingleRange = props => (
  <Range {...props} onChange={data => props.onChange({ value: data })} />
);

SingleRange.propTypes = {
  onChange: PropTypes.func.isRequired,
  ...Range.propTypes,
};

SingleRange.defaultProps = {
  showBars: true, // eslint-disable-line react/default-props-match-prop-types
  isValid: true, // eslint-disable-line react/default-props-match-prop-types
  ...Range.defaultProps,
};

export default SingleRange;
